import React, { useState } from 'react'
import InfoTooltip from "../../components/InfoTooltip.js";
import CircleProgress from "../../components/CircleProgress";
import { ProgressBar } from "react-step-progress-bar";
import { Link, useLocation } from "react-router-dom";
import UserImageCircle from "../../components/UserImageCircle";
import { useTeam } from "../../providers/TeamProvider";
import User from "../../models/User";
import TeamMatchDetails from "./TeamMatchDetails";
import TalentDisplayName from '../../components/TalentDisplayName.js';

const TeamStatusActions = ({ onTeamAction, isDisabled, ...props }) => {
    const {
        team,
        canFavorite,
        removeFromFavorites,
        addToFavorites,
    } = useTeam();

    const tooltipId = `${team?.id}-browse`
    const favoriteId = "fav-btn-" + tooltipId;

    return (
        <div className="candidate-status-actions">

            {canFavorite && (
                <React.Fragment>
                    <button
                        className="btn like-btn"
                        style={styles.favoriteBtn}
                        onClick={() => onTeamAction(
                            team.is_favorite ?
                                removeFromFavorites :
                                addToFavorites
                        )}
                        id={favoriteId}
                        disabled={isDisabled}>
                        <i className={"text-danger fa-heart " + (team.is_favorite ? "fas" : "far")} />
                    </button>

                    <InfoTooltip key={favoriteId + 'tooltip'} type={"dark"} target={favoriteId}>
                        {team.is_favorite ? "Remove from saved" : "Save as Favorite"}
                    </InfoTooltip>
                </React.Fragment>
            )}
        </div>
    )
}

const TeamTile = ({ children, ...props }) => {
    const {
        team,
        matchingDisciplines,
        criteria
    } = useTeam();

    const location = useLocation();

    const showMatchDetails = () => {
        let matchCriteria = {};
        if (criteria) {
            matchCriteria = criteria;
        }

        return TB.event('Modal@show', {
            modalClass: 'match-details-modal',
            content: (
                <TeamMatchDetails
                    team={team}
                    isEngagementLead={false}
                    criteria={matchCriteria}
                />
            )
        })
    }

    const onTeamAction = async (request) => {
        let update = await props.onRequest(request);
        // console.log('onTeamAction', update)
        // if (update && props.onUpdated) {
        //     await props.onUpdated(update);
        // }
    }


    let getUserDetailsLink = (user) => {

        let params = {
            team_id: team.id
        }

        let state = {
            linkParams: {
                title: 'Back',
                path: location.pathname + (location.search || '')
            }
        }

        return {
            ...location,
            pathname: `${location.pathname}/team-profiles/${team.id}/talent-profiles/${user.id}`,
            state
        }
    }

    let getTeamDetailsLink = () => {
        let state = {
            linkParams: {
                title: 'Back',
                path: location.pathname + (location.search || '')
            }
        }
        return {
            ...location,
            pathname: `team-profiles/${team.id}`,
            state
        }
    }

    const vips = TB.filter(team.topPositionsForDisplay(), vip => TB.isDefined(vip)).map(vip => User.make({ ...vip }));

    const [targetId, setTargetId] = useState("tooltip" + TB.guid());

    const [metrics, setMetrics] = useState(team.metricScores());

    if (props.placeholder) {
        return <TeamTileSkeleton>{children}</TeamTileSkeleton>;
    }

    return (
        <div className="candidate-panel">

            {/*<div className="candidate-status-header shortlisted">*/}
            {/*    <p>*/}
            {/*        Available: {team?.availableStartDate()}*/}
            {/*    </p>*/}

            {/*</div>*/}


            <div className="pt-2">

                <div className="px-4">
                    <TeamStatusActions
                        isDisabled={props.isDisabled}
                        shortlistView={props.shortlistView}
                        onTeamAction={onTeamAction}
                    />

                    <div className="team-info-panel">

                        <div className="top-info">

                            <p className="team-title text-center">{team.name}</p>

                            <div className="team-info-container">
                                {(team.type === 'Agency' && team.supplier_client) ? (
                                    <Link className="text-primary flex items-center gap-2 text-xxs hover:underline" to={`/agency-profiles/${team.supplier_client.id}`}>
                                        <img className="h-5" src={team.supplier_client.logo_path} />
                                        {team.type}
                                    </Link>
                                ) : (
                                    <span className="truncating-text team-info-text">
                                        <i className="fa fa-info-circle" />
                                        <p>{team.type}</p>
                                    </span>
                                )}

                                {team.location && team.location?.city && team.location?.state && (
                                    <span className="truncating-text team-info-text">
                                        <i className="fa fa-map-marker-alt" />
                                        <p>{team.location.city}{!!team.location.state && `, ${team.location.state}`}</p>
                                    </span>
                                )}
                            </div>


                            <p className="truncating-text team-bio">
                                {team.shortBio()}{team.fullBio()?.length > 65 && '...'}
                            </p>
                            <Link className="details-link"
                                to={getTeamDetailsLink()}>
                                {TB.trans('teams.project_info_panel.detail_link')}
                            </Link>


                        </div>


                        <div className="team-members-row mx-[-1rem] my-2">

                            {vips.map((user, i) => (
                                <Link key={`teamVIPUser${i}`}
                                    to={getUserDetailsLink(user)}
                                    className="flex flex-1 flex-col items-center">

                                    {/* <Img
                                        loader={(
                                            <div className="self-stretch justify-center items-center flex flex-col">
                                                <LoadingSpinner />
                                            </div>
                                        )}
                                        unloader={<UserImageCircle user={user} hideTooltip={true} size={60} />}
                                        src={user.image_path}
                                        className="img-grayscale img-fluid" /> */}
                                    <UserImageCircle user={user} hideTooltip={true} size={60} className="img-grayscale img-fluid" />

                                    <TalentDisplayName talent={user}>
                                        <p className="member-name">{user.firstNamePlusInitial()}</p>
                                    </TalentDisplayName>

                                    <p className="line-clamp-1 mx-2 text-xxs text-center">
                                        {user.job_title}
                                    </p>
                                </Link>
                            )
                            )}

                        </div>
                    </div>



                    {team?.hasMatching() && (
                        <div className="team-matching">
                            <div className="metric-container flex-col items-center self-center gap-3">

                                <CircleProgress
                                    className="metric-circle self-center w-[8.5rem]"
                                    progress={team.overallMatchPercent()}
                                    strokeWidth={7}
                                >
                                    <p>
                                        <span className="text-xl">{team.overallMatchPercent(true)}%</span>
                                        <small className="text-xs">Match</small>
                                    </p>
                                </CircleProgress>

                                <button type="button" className="details-link" onClick={showMatchDetails}>
                                    More...
                                </button>

                            </div>
                        </div>
                    )}
                </div>
                <hr className="m-0 mt-2" />

                <div className="candidate-rate-section">
                    <h4>Average Standard Rate</h4>
                    <h2 className="currency-sup">
                        {team.rangedPlatformRates()}
                        <span>/hr</span>
                    </h2>
                </div>

                {children}


            </div>
        </div>
    )
}

const TeamTileSkeleton = ({ children, ...props }) => {

    const metricLabels = [
        (<span key="skill-plh">
            <span>Skill</span>
            <span>Expertise</span>
        </span>),
        (<span key="exp-plh">
            <span>Years</span>
            <span>Experience</span>
        </span>),
        (<span key="industry-plh">
            <span>Industry</span>
            <span>Experience</span>
        </span>),
    ];

    return (
        <div className="talent-panel potential-talent-panel relative">
            <div className="flex">
                <div className="availability-label" />
            </div>

            <div className="card pt-2 border-none flex-1">
                <div className="team-info-panel team-info-panel">

                    <div className="top-info">

                        <div className="talent-info-placeholder" style={{
                            width: 100,
                            height: 22,
                            alignSelf: 'center',
                        }} />

                        <div className="team-info-container">
                            <span className="truncating-text team-info-text">
                                <div className="talent-info-placeholder" style={{
                                    width: 90,
                                    height: 10,
                                }} />
                            </span>

                            <span className="truncating-text team-info-text">
                                <div className="talent-info-placeholder" style={{
                                    width: 90,
                                    height: 10,
                                }} />
                            </span>
                        </div>


                        <div className="talent-info-placeholder" style={{
                            height: 14,
                            width: 300,
                            alignSelf: 'center',
                        }} />
                        <div className="talent-info-placeholder" style={{
                            height: 14,
                            width: 80,
                            alignSelf: 'center',
                        }} />
                        <p className="details-link" style={{
                            color: '#334D6E',
                            opacity: 0.6,
                        }}>See Details</p>
                    </div>

                    <div className="talent-matching">

                        <div className="overall-matching px-4">
                            <p className="overall-progress">
                                <span style={{ opacity: 0.6 }}>% Total Match</span>
                            </p>
                            <ProgressBar
                                filledBackground={TB.config('color.orange')}
                                height={20}
                                percent={0}
                                unfilledBackground={TB.config('color.gray')} />
                        </div>


                        <div className="metric-container">

                            {metricLabels.map((label, i) => (
                                <div key={`team-${i}`} className="metric-match disabled">
                                    <p>{label}</p>
                                    <CircleProgress
                                        className="metric-circle"
                                        progress={0}
                                        strokeWidth={7}>
                                        <p>
                                            <span>
                                                <span>%</span>
                                                <small>Match</small>
                                            </span>
                                        </p>
                                    </CircleProgress>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="potential-talent-footer">
                        <h4>Standard Rate</h4>
                        <h2>$/hr</h2>
                    </div>

                    {!!children && (

                        <div className="potential-talent-actions">
                            {children}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TeamTile;


const styles = {
    favoriteBtn: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },

    archiveBtn: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    inviteLockIcon: {
        position: 'absolute',
        fontSize: 13,
        right: -18,
    }
};